import { Module } from 'wrapper6'

const $ = jQuery

export default class PlantGuide extends Module {
  ready (app) {
    this.TABS = document.querySelectorAll('.tab')
    this.CONTENTS = document.querySelectorAll('.content')
    this.BUTTONS = document.querySelectorAll('.plant-guide-btn')
    this.addEventlisteners()
    this.subNavClick()
    this.subNavTab()
    this.buttonClick()
  }

  addEventlisteners () {
    const thisClass = this
    for (let i = 0; i < this.TABS.length; i++) {
      const TAB = this.TABS[i]

      TAB.addEventListener('click', function () {
        const id = this.getAttribute('data-id')
        thisClass.changeTab(id, false, true)
      })
    }

    for (let i = 0; i < this.BUTTONS.length; i++) {
      const BUTTON = this.BUTTONS[i]

      const that = this
      BUTTON.addEventListener('click', function () {
        const id = this.getAttribute('data-id')
        if (that.getScreenWidth() > 1200) {
          thisClass.changeTab(id, true)
        } else {
          thisClass.changeTab(id, false, true)
        }
      })
    }
  }

  changeTab (id, scrollToTop = false, scrollToContent) {
    if (document.querySelector('.tab.active')) {
      document.querySelector('.tab.active').classList.remove('active')
      document.querySelector('.content.active').classList.remove('active')
    }
    document.querySelector('.tab[data-id="' + id + '"]').classList.add('active')
    document.querySelector('.content[data-id="' + id + '"]').classList.add('active')

    const resizeEvent = window.document.createEvent('UIEvents')
    resizeEvent.initUIEvent('resize', true, false, window, 0)
    window.dispatchEvent(resizeEvent)

    let offset = 0
    const navHeight = 80
    const adminBarHeight = 32
    const topBarHeight = 40
    const spacingHeight = 32
    if ($('body').hasClass('admin-bar')) {
      offset = navHeight + adminBarHeight + topBarHeight + spacingHeight
      if ($(window).width() <= 1160 && $(window).width() > 783) {
        offset = navHeight + adminBarHeight + spacingHeight
      } else if ($(window).width() <= 782) {
        offset = navHeight + spacingHeight - 16
      }
    } else {
      offset = navHeight + topBarHeight + spacingHeight
      if ($(window).width() <= 1160) {
        offset = navHeight + spacingHeight
      }
    }

    if (scrollToTop) {
      $('html, body').animate({ scrollTop: $('#scroll-to-destination-tabs').offset().top - offset }, 400)
    }

    if (scrollToContent && $(window).width() < 1200) {
      $('html, body').animate({ scrollTop: $('#scroll-to-destination-content').offset().top - offset + 32 }, 400)
    }
  }

  subNavClick () {
    const ANCHORS = document.querySelectorAll('a')

    for (let i = 0; i < ANCHORS.length; i++) {
      const ANCHOR = ANCHORS[i]
      ANCHOR.addEventListener('click', function (e) {
        // send tab with on click
        if (this.hasAttribute('data-link')) {
          let DATA_LINK = this.getAttribute('data-link')
          DATA_LINK = parseInt(DATA_LINK)
          DATA_LINK = DATA_LINK - 1

          const URL_HREF = this.getAttribute('href')
          const FINAL_URL = URL_HREF + '?tab=' + DATA_LINK
          this.setAttribute('href', FINAL_URL)
        }
      })
    }
  }

  subNavTab () {
    const URL = window.location.href
    const DATA_LINK = URL.charAt(URL.length - 1)

    const TABS = document.querySelectorAll('.tab')
    const CONTENT = document.querySelectorAll('.content')

    if (URL.includes('tab')) {
      for (let i = 0; i < TABS.length; i++) {
        const TAB = TABS[i]

        TAB.classList.remove('active')

        if (TAB.getAttribute('data-id') == DATA_LINK) {
          TAB.classList.add('active')
        }
      }

      for (let j = 0; j < CONTENT.length; j++) {
        const SINGLE_CONTENT = CONTENT[j]
        SINGLE_CONTENT.classList.remove('active')

        if (SINGLE_CONTENT.getAttribute('data-id') == DATA_LINK) {
          SINGLE_CONTENT.classList.add('active')

          // setTimeout(() => {

          //     $('html, body').animate({
          //         scrollTop: $('.content.active').offset().top - 250
          //     }, 500)
          // }, 50);
        }
      }
    }
  }

  buttonClick () {
    const BUTTONS = document.querySelectorAll('button')
    const CONTENT_CONTAINERS = document.querySelectorAll('.content')

    BUTTONS.forEach(BUTTON => {
      BUTTON.addEventListener('click', function () {
        if (this.hasAttribute('data-link')) {
          const ID = parseInt(this.getAttribute('data-link'))

          CONTENT_CONTAINERS.forEach(CONTENT => {
            const CONTENT_ID = CONTENT.getAttribute('data-id')

            CONTENT.classList.remove('active')

            if (parseInt(CONTENT_ID) + 1 === ID) {
              CONTENT.classList.add('active')
              document.querySelector('.tab.active').classList.remove('active')
              document.querySelector('.tab[data-id="' + CONTENT_ID + '"]').classList.add('active')
            }
          })
        }
      })
    })
  }

  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }
}
